
const Aguardando = (props) => {   

    return (                      
        <div className="container-dado-alt fadein animation-ease-in-out animation-duration-3000 animation-delay-3000 animation-iteration-infinite 
            flex align-items-center justify-content-center h-full">
            Aguardando a leitura dos Boletins de Urna...
        </div>        
    );
}

export default Aguardando;